import axiosInstance from "../utilities/axiosSetup";

export const create_tier4_interpreter = async (interpreterData) => {
  try {
    const { data } = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/create-tier-4-interpreter",
      interpreterData,
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const list_interpreters = async () => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/list-interpreters",
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const list_paginated_interpreters = async (page, page_size, search_text) => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/list-paginated-interpreters",
      {
        params: { page: page, page_size: page_size, search_text: search_text },
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const get_engagement_attributes = async (engagement_id) => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/get-engagement-attributes",
      {
        params: { engagement_id: engagement_id },
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const get_attributes_by_call_interpreter = async (engagement_id) => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/get-attributes-by-call-interpreter",
      {
        params: { engagement_id: engagement_id },
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const update_interpreter_special_id = async (
  interpreter_id,
  interpreter_special_id
) => {
  try {
    const { data } = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/update-interpreter-special-id",
      {
        interpreter_id: interpreter_id,
        interpreter_special_id: interpreter_special_id,
      },
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const get_interpreter_by_id = async (interpreter_id) => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/get-interpreter-by-id",
      {
        params: { interpreter_id: interpreter_id },
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const update_interpreter = async (interpreterData) => {
  try {
    const { data } = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/update-tier-4-interpreter",
      interpreterData,
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const get_interpreter_tiers = async (interpreter_id) => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/get-interpreter-tiers",
      {
        params: { interpreter_id: interpreter_id },
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const get_interpreter_queues = async (z_user_id) => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/get-interpreter-queues",
      {
        params: { z_user_id: z_user_id },
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const disable_tier4_interpreter = async (interpreter_id) => {
  try {
    const { data } = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/disable-tier-4",
      {
        interpreter_id: interpreter_id,
      },
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const get_interpreter_rates = async (interpreter_id) => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/get-interpreter-rates/" + interpreter_id,
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
